// KbLayout.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import Landing from "layouts/Landing";
import KnowledgeBase from "views/Pages/KnowledgeBase/KnowledgeBase";
import Home from "views/Pages/KnowledgeBase/components/Home";
import Articles from "views/Pages/KnowledgeBase/components/Articles";
import Article from "views/Pages/KnowledgeBase/components/Article";
import NewArticle from "views/Pages/KnowledgeBase/components/NewArticle";

const KbLayout = () => {
  return (
    <Landing>
      <Routes>
        <Route path="/" element={<KnowledgeBase />}>
          <Route index element={<Home />} />
          <Route path="articles" element={<Articles />} />
          <Route path="articles/post/:articleId" element={<Article />} />
          <Route path="new-post" element={<NewArticle />} />
        </Route>
      </Routes>
    </Landing>
  );
};

export default KbLayout;
